var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartRouteNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FC8F37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_3001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 13.3333L10.6666 11.3333M14.0068 6.33325V5.33325M16.633 7.37369L17.3401 6.66659M16.633 12.6666L17.3401 13.3737M11.3401 7.37369L10.633 6.66659M17.6735 9.99992H18.6735M8.08748 17.9123L14.2457 11.7542C14.5097 11.4902 14.6417 11.3581 14.6911 11.2059C14.7346 11.072 14.7346 10.9278 14.6911 10.7939C14.6417 10.6417 14.5097 10.5097 14.2457 10.2457L13.7541 9.75417C13.4901 9.49015 13.3581 9.35815 13.2059 9.30869C13.072 9.26518 12.9278 9.26518 12.7939 9.30869C12.6417 9.35815 12.5097 9.49015 12.2457 9.75417L6.08748 15.9123C5.82347 16.1763 5.69146 16.3084 5.642 16.4606C5.5985 16.5945 5.5985 16.7387 5.642 16.8726C5.69146 17.0248 5.82347 17.1568 6.08748 17.4208L6.57899 17.9123C6.843 18.1763 6.975 18.3084 7.12722 18.3578C7.26112 18.4013 7.40535 18.4013 7.53924 18.3578C7.69146 18.3084 7.82347 18.1763 8.08748 17.9123Z",
    stroke: "#FFF4F0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_3001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartRouteNodeIcon);
export default __webpack_public_path__ + "static/media/smartRouteNodeIcon.15d6f1ce3a43fb6a23b08ff38311f753.svg";
export { ForwardRef as ReactComponent };